/**
 * @generated SignedSource<<afbc389a328e98c617b5824be8a1c86d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomePageQuery$variables = Record<PropertyKey, never>;
export type HomePageQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"RightNav_viewer">;
  };
};
export type HomePageQuery = {
  response: HomePageQuery$data;
  variables: HomePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  (v0/*: any*/)
],
v7 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "Meeting",
  "abstractKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "Position",
  "abstractKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "Project",
  "abstractKey": null
},
v10 = [
  (v1/*: any*/),
  (v0/*: any*/)
],
v11 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "Comment",
  "abstractKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "Like",
  "abstractKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "Membership",
  "abstractKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "Task",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RightNav_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HomePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "user",
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserClubConnection",
                "kind": "LinkedField",
                "name": "clubs",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserClubEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "kind",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v2/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "unreadNotifications",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": "unread"
                  }
                ],
                "concreteType": "NotificationConnection",
                "kind": "LinkedField",
                "name": "notifications",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": "notifications(filter:\"unread\")"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "NotificationConnection",
                "kind": "LinkedField",
                "name": "notifications",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Notification",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "read",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "action",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "actor",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "email",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageUrl",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "target",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v2/*: any*/),
                                "type": "Project",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v2/*: any*/),
                                "type": "Position",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v2/*: any*/),
                                "type": "Meeting",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v0/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "parent",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v0/*: any*/),
                                          (v1/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "parent",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v2/*: any*/),
                                                "type": "TaskableInterface",
                                                "abstractKey": "__isTaskableInterface"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v6/*: any*/),
                                                "type": "Club",
                                                "abstractKey": null
                                              },
                                              (v7/*: any*/),
                                              (v8/*: any*/),
                                              (v9/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "Task",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v2/*: any*/),
                                        "type": "AssignableInterface",
                                        "abstractKey": "__isAssignableInterface"
                                      },
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Assignment",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v0/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v6/*: any*/),
                                        "type": "CommentableInterface",
                                        "abstractKey": "__isCommentableInterface"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v10/*: any*/),
                                        "type": "Project",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v10/*: any*/),
                                        "type": "Position",
                                        "abstractKey": null
                                      },
                                      (v5/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v6/*: any*/),
                                        "type": "Assignment",
                                        "abstractKey": null
                                      },
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v7/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "NotificationTargetInterface",
                                "abstractKey": "__isNotificationTargetInterface"
                              },
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "notifications(first:10)"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": [
                  "filter"
                ],
                "handle": "connection",
                "key": "Notifications_user_notifications",
                "kind": "LinkedHandle",
                "name": "notifications"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4b7a9da5f922bcc1555e18b7377fe5db",
    "id": null,
    "metadata": {},
    "name": "HomePageQuery",
    "operationKind": "query",
    "text": "query HomePageQuery {\n  viewer {\n    ...RightNav_viewer\n  }\n}\n\nfragment Avatar_user on User {\n  id\n  name\n  email\n  imageUrl\n}\n\nfragment ClubDropDown_user on User {\n  id\n  clubs {\n    edges {\n      id\n      kind\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment Notifications_user_4CDKww on User {\n  id\n  unreadNotifications: notifications(filter: unread) {\n    totalCount\n  }\n  notifications(first: 10) {\n    totalCount\n    edges {\n      node {\n        id\n        read\n        action\n        createdAt\n        actor {\n          id\n          name\n          ...Avatar_user\n        }\n        target {\n          __typename\n          ... on Project {\n            id\n            name\n          }\n          ... on Position {\n            id\n            name\n          }\n          ... on Meeting {\n            id\n            name\n          }\n          ... on Assignment {\n            id\n            parent {\n              __typename\n              ... on Task {\n                id\n                name\n                __typename\n                parent {\n                  __typename\n                  ... on TaskableInterface {\n                    __isTaskableInterface: __typename\n                    id\n                    name\n                    __typename\n                  }\n                  ... on Club {\n                    id\n                  }\n                  ... on Meeting {\n                    id\n                  }\n                  ... on Position {\n                    id\n                  }\n                  ... on Project {\n                    id\n                  }\n                }\n              }\n              ... on AssignableInterface {\n                __isAssignableInterface: __typename\n                id\n                name\n                __typename\n              }\n              ... on Meeting {\n                id\n              }\n              ... on Position {\n                id\n              }\n              ... on Project {\n                id\n              }\n            }\n          }\n          ... on NotificationTargetInterface {\n            __isNotificationTargetInterface: __typename\n            id\n            __typename\n            source {\n              ... on CommentableInterface {\n                __isCommentableInterface: __typename\n                id\n              }\n              ... on Project {\n                name\n                id\n              }\n              ... on Position {\n                name\n                id\n              }\n              __typename\n              ... on Assignment {\n                id\n              }\n              ... on Comment {\n                id\n              }\n              ... on Like {\n                id\n              }\n              ... on Meeting {\n                id\n              }\n              ... on Membership {\n                id\n              }\n              ... on Task {\n                id\n              }\n            }\n          }\n          ... on Comment {\n            id\n          }\n          ... on Like {\n            id\n          }\n          ... on Membership {\n            id\n          }\n          ... on Task {\n            id\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RightNav_viewer on Viewer {\n  user: currentUser {\n    ...ClubDropDown_user\n    ...Notifications_user_4CDKww\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "907678d2fe747559b9e4395bcef3d8b1";

export default node;
